module.exports = __webpack_public_path__ + "img/Group3.ca986e9a.png";